import React, { Fragment, useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { Container } from 'reactstrap';
import { withTranslation } from 'react-i18next';
import { includes } from 'lodash';
import MDTIcon from '../../atoms/mdt-iconset/index.js';
import './breadcrumb.css';
import { MDTApp } from '../../../actions/bootAction.js';

const MDTBreadcrumb = ({ t, config, className, onPageClick, dataTest = 'mdt-breadcrumb' }) => {
    const [pageList, setPageList] = useState([]);
    const [hidden, setHidden] = useState(false);
    const portalLink = MDTApp.getSetting('links.login', '', false);
    const homeLink = MDTApp.getSetting('links.home', '', false);
    useEffect(() => {
        const pageList = getPageList();
        setPageList(pageList);
    }, [config.page, config.breadCrumbs.length]);

    const getPageList = () => {
        const { breadCrumbs, page, homeKey } = config;
        const breadCrumb = breadCrumbs[page] ? breadCrumbs[page] : [];
        const homeCrumb = breadCrumbs[homeKey];
        if (breadCrumb.length) {
            const hideOnMobile = breadCrumb.some((item) => item.hideOnMobile);
            setHidden(!!hideOnMobile);

            let topCrumbs = [];
            const { referrer } = document;
            if (referrer) {
                topCrumbs = [
                    {
                        label: '',
                        referrer,
                    },
                    homeCrumb,
                ];
            } else {
                topCrumbs = [homeCrumb];
            }
            return topCrumbs.concat(breadCrumb);
        }
        return [];
    };

    const pagesCount = pageList.length;

    if (!pageList.length) return null;
    return (
        <div
            id='breadcrumb-nav'
            role='navigation'
            aria-label='breadcrumbs'
            className={classNames('mdt-breadcrumb d-sm-block', className, { 'd-none': hidden })}
            data-test={dataTest}
        >
            <Container className='my-0'>
                <ul>
                    {pageList.map((page, index) => {
                        return (
                            <>
                                {page.link && (
                                    <>
                                        <li className='chevron-li'>
                                            <MDTIcon name='chevron-forward-thin' />
                                        </li>
                                        <li
                                            data-test={`breadcrumb-child-${index}`}
                                            key={index}
                                            className={
                                                index === pagesCount - 2
                                                    ? 'parent-li last-parent'
                                                    : 'parent-li'
                                            }
                                        >
                                            <a
                                                className='body2 link'
                                                href='#'
                                                data-test={page.dataTest}
                                                onClick={(e) => {
                                                    e.preventDefault();
                                                    onPageClick(page);
                                                }}
                                            >
                                                {t(page.label)}
                                            </a>
                                        </li>
                                    </>
                                )}

                                {page.referrer &&
                                    !includes(page.referrer, portalLink) &&
                                    !includes(document.referrer, homeLink) && (
                                        <>
                                            <li key={index} className='referrer'>
                                                <a
                                                    className='body2 link referrer'
                                                    href='#'
                                                    onClick={(e) => {
                                                        e.preventDefault();
                                                        MDTApp.goto(page.referrer);
                                                    }}
                                                >
                                                    <MDTIcon name='chevron-back-double' />
                                                </a>
                                            </li>
                                            <li className='pipe-li'>
                                                <MDTIcon name='pipe-thin' />
                                            </li>
                                        </>
                                    )}
                                {!(page.link || page.referrer) && (
                                    <>
                                        <li className='no-link chevron-li'>
                                            <MDTIcon name='chevron-forward-thin' />
                                        </li>
                                        <li
                                            data-test={`breadcrumb-child-${index}`}
                                            className='no-link child-li'
                                        >
                                            {t(page.label)}
                                        </li>
                                    </>
                                )}
                            </>
                        );
                    })}
                </ul>
            </Container>
        </div>
    );
};

MDTBreadcrumb.prototype = {
    pageList: PropTypes.array.isRequired,
    onPageClick: PropTypes.func.isRequired,
};

export default withTranslation()(MDTBreadcrumb);
